import { showSnackbar, snackbarTypes } from 'src/redux/snackbar'
import { fetchDispatch } from 'data/helpers'

export const GET_AI_JOBS_LOADING = 'aiJobs/GET_AI_JOBS_LOADING'
export const GET_AI_JOBS_SUCCESS = 'aiJobs/GET_AI_JOBS_SUCCESS'
export const GET_AI_JOBS_FAILURE = 'aiJobs/GET_AI_JOBS_FAILURE'

export const GET_AI_JOBS_FUZZY_LOADING = 'aiJobs/GET_AI_JOBS_FUZZY_LOADING'
export const GET_AI_JOBS_FUZZY_SUCCESS = 'aiJobs/GET_AI_JOBS_FUZZY_SUCCESS'
export const GET_AI_JOBS_FUZZY_FAILURE = 'aiJobs/GET_AI_JOBS_FUZZY_FAILURE'

export const GET_AI_JOB_QUESTION_LOADING = 'aiJobs/GET_AI_JOB_QUESTION_LOADING'
export const GET_AI_JOB_QUESTION_SUCCESS = 'aiJobs/GET_AI_JOB_QUESTION_SUCCESS'
export const GET_AI_JOB_QUESTION_FAILURE = 'aiJobs/GET_AI_JOB_QUESTION_FAILURE'

export const UPDATE_AI_JOB_FAVORITE = 'aiJobs/UPDATE_AI_JOB_FAVORITE'

export const ADD_CHAT_MESSAGE = 'aiJobs/ADD_CHAT_MESSAGE'
export const CLEAR_CHAT_HISTORY = 'aiJobs/CLEAR_CHAT_HISTORY'
export const SET_AI_TYPING = 'aiJobs/SET_AI_TYPING'

export const getAiJobsLoading = () => ({ type: GET_AI_JOBS_LOADING })
export const getAiJobsSuccess = payload => ({ type: GET_AI_JOBS_SUCCESS, payload })
export const getAiJobsFailure = payload => ({ type: GET_AI_JOBS_FAILURE, payload })

export const getAiJobsFuzzyLoading = () => ({ type: GET_AI_JOBS_FUZZY_LOADING })
export const getAiJobsFuzzySuccess = payload => ({ type: GET_AI_JOBS_FUZZY_SUCCESS, payload })
export const getAiJobsFuzzyFailure = payload => ({ type: GET_AI_JOBS_FUZZY_FAILURE, payload })

export const getAiJobQuestionLoading = () => ({ type: GET_AI_JOB_QUESTION_LOADING })
export const getAiJobQuestionSuccess = payload => ({ type: GET_AI_JOB_QUESTION_SUCCESS, payload })
export const getAiJobQuestionFailure = payload => ({ type: GET_AI_JOB_QUESTION_FAILURE, payload })

export const updateAiJobFavorite = payload => ({ type: UPDATE_AI_JOB_FAVORITE, payload })

export const addChatMessage = payload => ({ type: ADD_CHAT_MESSAGE, payload })
export const clearChatHistory = () => ({ type: CLEAR_CHAT_HISTORY })
export const setAiTyping = payload => ({ type: SET_AI_TYPING, payload })

export const fetchAIJobs = ({ values }) => {
  return async dispatch => {
    dispatch(getAiJobsLoading())
    try {
      const response = await fetchDispatch({
        path: '/api/ai/jobs_from_database',
        method: 'POST',
        values: {
          candidatePrompt: values.prompt,
          previousJobs: values.previousJobs,
        },
      })

      dispatch(getAiJobsSuccess(response))
    } catch (error) {
      dispatch(
        showSnackbar(
          'Sorry! We encountered an error finding you jobs. Check back again!',
          snackbarTypes.ERROR,
        ),
      )
      dispatch(getAiJobsFailure(error.response))
    }
  }
}

export const fetchAIJobsFuzzy = ({ values }) => {
  return async dispatch => {
    dispatch(getAiJobsFuzzyLoading())
    try {
      const response = await fetchDispatch({
        path: '/api/ai/jobs_from_database',
        method: 'POST',
        values: {
          candidatePrompt: values.prompt,
          previousJobs: values.previousJobs,
          criteriaBehavior: 2,
        },
      })
      dispatch(getAiJobsFuzzySuccess(response))
    } catch (error) { 
      dispatch(getAiJobsFuzzyFailure(error.response))
    }
  }
}

export const fetchAIJobQuestion = ({ jobId, question }) => {
  return async dispatch => {
    dispatch(getAiJobQuestionLoading())
    try {
      const response = await fetchDispatch({
        path: '/api/ai/ai_job_info',
        method: 'POST',
        values: {
          jobId,
          question,
        },
      })
      dispatch(getAiJobQuestionSuccess(response))
    } catch (error) {
      dispatch(getAiJobQuestionFailure(error.response))
    }
  }
}

const initialState = {
  loading: false,
  exactMatches: {
    jobs: [],
    reasonForSelection: null,
    totalCount: 0
  },
  fuzzyMatchesLoading: false,
  fuzzyMatches: {
    jobs: [],
    reasonForSelection: null,
    totalCount: 0
  },
  hospitalMatches: {
    hospitals: []
  },
  jobQuestions: {},
  jobQuestionsLoading: {},
  chatHistory: [],
  isAiTyping: false
}

export const aiJobSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AI_JOBS_LOADING:
      return { ...state, loading: true }
    case GET_AI_JOBS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        exactMatches: {
          jobs: action.payload.jobs || [],
          reasonForSelection: action.payload.reasonForSelection || null,
          totalCount: action.payload.totalCount || 0
        }
      }
    case GET_AI_JOBS_FAILURE:
      return { ...state, loading: false }
    case GET_AI_JOB_QUESTION_LOADING:
      return {
        ...state,
        jobQuestionsLoading: { ...state.jobQuestionsLoading, [action.payload.jobId]: true }
      }
    case GET_AI_JOB_QUESTION_SUCCESS:
      return {
        ...state,
        jobQuestionsLoading: { ...state.jobQuestionsLoading, [action.payload.jobId]: false },
        jobQuestions: { 
          ...state.jobQuestions, 
          [action.payload.jobId]: action.payload.questionResponses 
        }
      }
    case GET_AI_JOB_QUESTION_FAILURE:
      return {
        ...state,
        jobQuestionsLoading: { ...state.jobQuestionsLoading, [action.payload.jobId]: false }
      }
    case GET_AI_JOBS_FUZZY_LOADING:
      return { ...state, fuzzyMatchesLoading: true }
    case GET_AI_JOBS_FUZZY_SUCCESS:
      return { 
          ...state, 
          fuzzyMatchesLoading: false,
          fuzzyMatches: {
            jobs: action.payload.jobs || [],
            reasonForSelection: action.payload.reasonForSelection || null,
            totalCount: action.payload.totalCount || 0
          }
        }
    case GET_AI_JOBS_FUZZY_FAILURE:
      return { ...state, fuzzyMatchesLoading: false }
    case UPDATE_AI_JOB_FAVORITE:
      return {
        ...state,
        exactMatches: {
          ...state.exactMatches,
          jobs: state.exactMatches.jobs.map(job =>
            job.id === action.payload.jobId
              ? {
                  ...job,
                  candidateJob: {
                    ...job.candidateJob,
                    favorite: action.payload.favorite,
                  },
                }
              : job
          ),
        },
        fuzzyMatches: {
          ...state.fuzzyMatches,
          jobs: state.fuzzyMatches.jobs.map(job =>
            job.id === action.payload.jobId
              ? {
                  ...job,
                  candidateJob: {
                    ...job.candidateJob,
                    favorite: action.payload.favorite,
                  },
                }
              : job
          ),
        },
      }
    case ADD_CHAT_MESSAGE:
      return {
        ...state,
        chatHistory: [...state.chatHistory, {
          id: Date.now() + Math.random(), // Simple unique ID
          type: action.payload.type, // 'user' or 'ai'
          message: action.payload.message,
          timestamp: new Date().toISOString(),
          ...action.payload.metadata // Any additional metadata
        }]
      }
    case CLEAR_CHAT_HISTORY:
      return {
        ...state,
        chatHistory: []
      }
    case SET_AI_TYPING:
      return {
        ...state,
        isAiTyping: action.payload
      }
    default:
      return state
  }
}
